module.exports = __webpack_public_path__ + "static/img/08.b219e43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/04/08.jpg
// module id = /CN7
// module chunks = 0